$(document).ready(function () {
  $(window).scroll(function () {
    if ($(this).scrollTop() > 20) {
      $("#toTopBtn").show();
    } else {
      $("#toTopBtn").hide();
    }
  });

  $("#toTopBtn").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  });

  $(window).scroll(function () {
    if (
      $(document).height() - $(window).height() - $(window).scrollTop() ===
      0
    ) {
      $("#toBottomBtn").fadeOut();
    } else {
      $("#toBottomBtn").fadeIn();
    }
  });

  $("#toBottomBtn").click(function () {
    $("html, body").animate({ scrollTop: $(document).height() }, 1000);
    return false;
  });

  var lastScrollTop = 0;
  $(window).scroll(function () {
    var currentScroll = $(this).scrollTop();
    var header = $(".header-sticky-wrapper");

    if (currentScroll > lastScrollTop) {
      header.attr("style", "top: 0;");
    } else if (currentScroll > 20) {
      header.attr("style", "top: 0;");
    } else {
      header.attr("style", "top: initial;");
    }

    lastScrollTop = currentScroll;
  });

  // Country Selector Pop Up

  // window.onload = function () {
  //   $(".bts-popup").delay(1000).addClass("is-visible");
  // };

  //open popup
  $(".bts-popup-trigger").on("click", function (event) {
    event.preventDefault();
    $(".bts-popup").addClass("is-visible");
    $(".bts-popup-trigger").addClass("popup-visible");
  });

  //close popup
  $(".bts-popup").on("click", function (event) {
    if (
      $(event.target).is(".bts-popup-close") ||
      $(event.target).is(".bts-popup")
    ) {
      event.preventDefault();
      $(this).removeClass("is-visible");
      $(".bts-popup-trigger").removeClass("popup-visible");
    }
  });
  //close popup when clicking the esc keyboard button
  // $(document).keyup(function (event) {
  //   if (event.which == "27") {
  //     $(".bts-popup").removeClass("is-visible");
  //   }
  // });

  // Redirect user as per Selected Location

  $(".bts-popup-button").click(function () {
    var storeLocation = $("#storeDropdown").find(":selected").val();
    console.log(storeLocation);
    window.location.href = storeLocation;
  });

  // Relevant Variant Description Populate Function On Load

  $(document).ready(function ($) {
    $(".variant-input-wrap .variant-input input:checked").each(function () {
      var checkedLabel = $(this).siblings("label").text();
      var attrWithoutChar = checkedLabel.replace(/[^\w\s]/gi, "");
      attrWithoutChar = attrWithoutChar.replace(/\s+/g, "").toLowerCase();
      console.log("New Lowercase Swatch " + attrWithoutChar);

      $(".rte p, .rte ul, .rte h6").hide();

      $(".rte h6").each(function () {
        var h6Text = $(this)
          .text()
          .replace(/[^\w\s]/gi, "")
          .toLowerCase();
        if (h6Text === attrWithoutChar) {
          $(this).nextUntil("h6").show(); // Show elements after the matched <h6>
          console.log("Showing Elements for " + h6Text);
        } else {
          console.log("No match found for " + h6Text);
        }
      });
    });
  });

  // Relevant Variant Description Populate Function On Click

  $(document).on("click", ".variant-input", function () {
    var getAttribute = $(this).attr("data-value");
    var attrWithoutChar = getAttribute.replace(/[^\w\s]/gi, "");
    attrWithoutChar = attrWithoutChar.replace(/\s+/g, "").toLowerCase();
    console.log("New Lowercase Swatch " + attrWithoutChar);

    $(".rte p, .rte ul, .rte h6").hide();

    var targetH6;

    $(".rte h6").each(function () {
      var h6Text = $(this)
        .text()
        .replace(/[^\w\s]/gi, "")
        .toLowerCase();
      if (h6Text === attrWithoutChar) {
        var elementsToShow = $(this).nextUntil("h6");
        elementsToShow.show();
      } else {
        console.log("No match found!");
      }
    });
  });

  // Relevant Variant Images Populate Function

  $(document).on("click", ".variant-input", function () {
    var getAttribute = $(this).attr("data-value");
    var attrWithoutChar = getAttribute.replace(/[^\w\s]/gi, "");
    attrWithoutChar = attrWithoutChar.replace(/\s+/g, "-").toLowerCase();
    console.log("Lowercase " + attrWithoutChar);
    let appendText = "style";
    let appendedText = appendText.concat("_", attrWithoutChar);
    console.log(appendedText);
    var productImages = $(".product__thumb-item");
    for (var i = 0; i < productImages.length; i++) {
      var dataGroup = $(productImages[i]).attr("data-group");
      var getVariantAttr = dataGroup ? dataGroup.toLowerCase() : "";
      if (getVariantAttr === appendedText) {
        $(productImages[i]).show();
      } else {
        $(productImages[i]).hide();
      }
    }
  });
});
